module.exports = __webpack_public_path__ + "cd9b18e87a02d8a9d12087038e2a1c69.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1_variable/public/news/img1.jpg
// module id = 395
// module chunks = 0